import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { createRequestOption } from '../common/utils/request-util';

@Injectable({ providedIn: 'root' })
export class BusinessOperationsService {

  constructor(
    private http: HttpClient,
  ) {}

  queryUsersList(body) {
    return this.http.post(environment.urlBackEnd + 'agency/user/list/', body);
  }
  getInfoAgency(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'agency-organization/agency-partner/' + req.id,  {  params: options, observe: 'response' });
  }
  queryAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/agency-partner/list/', body);
  }
  getDetailAgency(agencyId) {
    return this.http.get(environment.urlBackEnd + `agency-organization/agency-partner/${agencyId}`);
  }
  createAgency(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/agency-partner/create', body);
  }
  updateAgency(body) {
    return this.http.put(environment.urlBackEnd + 'agency-organization/agency-partner/' + body.id, body);
  }
  activeAgency(body) {
    return this.http.put(environment.urlBackEnd + 'agency-organization/agency-partner/' + body.id  + '/enable', body);
  }
  lockAgency(body) {
    return this.http.put(environment.urlBackEnd + 'agency-organization/agency-partner/' + body.id  + '/disable', body);
  }
  getInfoIssuer(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'agency-organization/' + req.id,  {  params: options, observe: 'response' });
  }
  queryOrder(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/transaction-fee/list', body);
  }
  exportOrder(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/transaction-fee/export', body, { responseType:'blob', observe: 'response' });
  }
  exportInvestor(body) {
    return this.http.post(environment.urlBackEnd + 'agency/user/export/', body, { responseType:'blob', observe: 'response' });
  }
  queryListTrailerFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/list-fee/', body);
  }
  queryListTransactionFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/transaction-fee/list', body);
  }
  exportListTrailerFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/export-fee/', body, { responseType:'blob', observe: 'response' });
  }
  exportListTransactionFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/transaction-fee/export', body, { responseType:'blob', observe: 'response' });
  }
  queryListTrailerFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/agency-partner/' + body.id + '/list-fee/', body);
  }
  exportListTrailerFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/agency-partner/' + body.id + '/export-fee/', body, { responseType:'blob', observe: 'response' });
  }
  queryListTransactionFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/transaction-fee/list', body);
  }
  exportListTransactionFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/transaction-fee/export', body, { responseType:'blob', observe: 'response' });
  }
  createWithdrawalFee(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/create-claim-request/', body);
  }
  queryListWithdrawalFeeOrganization(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/list-claim-request/', body);
  }
  queryListWithdrawalFeePartner(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/list-partner-claim-request/', body);
  }
  confirmAllWithdrawalFee() {
    return this.http.post(environment.urlBackEnd + 'agency-organization/accept-all-partner-claim-request/', {});
  }
  rejectWithdrawalFee(body) {
    return this.http.post(environment.urlBackEnd + 'agency-organization/cancel-partner-claim-request/' + body.id, body);
  }
  queryRatingList(body) {
    return this.http.post(environment.urlBackEnd + 'agency/list-consulting-rating/', body);
  }
  statisticRating(body) {
    return this.http.post(environment.urlBackEnd + 'agency/average-consulting-rating/', body);
  }
  queryConsultantRequest(body) {
    return this.http.post(environment.urlBackEnd + 'life-hero/org/consult-request/list/', body);
  }
  queryConsultantRequestById(id){
    return this.http.get(environment.urlBackEnd + 'life-hero/org/consult-request/' + id);
  }
  assignAgencyPartner(body) {
    return this.http.put(environment.urlBackEnd + `life-hero/org/consult-request/${body.id}/assign-partner`, body);
  }
  queryInsuranceContracts(body){
    return this.http.post(environment.urlBackEnd + 'life-hero/org/contracts/list' , body);
  }
  queryContracts(body) {
    return this.http.post(environment.urlBackEnd + 'life-hero/org/contracts/list/', body);
  }
  queryContractById(id){
    return this.http.get(environment.urlBackEnd + 'life-hero/org/contracts/' + id);
  }
  loadSummaryConsultantRequest(){
    return this.http.get(environment.urlBackEnd + 'life-hero/org/consult-request/summary');
  }
  getSummaryInvestor(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'agency-organization/summary/count',  {  params: options });
  }
  getAssignPartnerAutoSetting(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + `life-hero/org/config/assign-partner-auto-setting`,  {  params: options });
  }
  updateAssignPartnerAutoSetting(body) {
    return this.http.put(environment.urlBackEnd + `life-hero/org/config/assign-partner-auto-setting`, body);
  }
}
